import React from 'react';
import {FemaGoModal} from 'app-ui-componentlibrary';
import {Button, Grid, Form, Card, Icon} from 'semantic-ui-react';
import {
  TextAreaField,
  TextBoxField,
  InlineTextBoxField,
} from 'app-ui-componentlibrary/dist/go/components/common/FormControls';
import _ from 'lodash';
import {connectDynamic} from 'go/components/dynamic/dynamicComponent';
import {
  isRequired,
  maxLength,
  minLength,
  greaterThan,
  regexMatch,
  lessThan,
} from 'go/components/rules/rules';
import {StaticText} from 'componentLibrary';
import {modalVal, onlyAllowNumbers} from 'common/utils';

const MODALS = {
  CREATE: 'create',
  EDIT: 'edit',
  NONE: 'none',
};

const MAX_LENGTHS = {
  TASK_NAME: 100,
  TASK_DESCRIPTION: 4000,
};
export class TaskSchedule extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      openModal: MODALS.NONE,
      scheduleTask: false,
      selectedIndex: -1,
      taskName: false,
      taskDescription: false,
      startMonth: false,
      duration: false,
    };
  }

  taskNameMessage = 'Please enter a task name.';
  taskDescriptionMessage = 'Please enter a task description';
  startMonthMessage = 'Please enter a month';
  durationMessage = 'Please enter a duration';

  validateName = (name, maxSize) => {
    return isRequired()(name) && minLength(1)(name) && maxLength(maxSize)(name);
  };
  validateStartMonth = (startMonth) => {
    return (
      isRequired()(startMonth) &&
      greaterThan(0)(startMonth) &&
      onlyAllowNumbers(startMonth) &&
      regexMatch(/^\d+$/)(startMonth)
    );
  };
  validateDuration = (duration) => {
    return (
      isRequired()(duration) &&
      greaterThan(0)(duration) &&
      onlyAllowNumbers(duration) &&
      regexMatch(/^\d+$/)(duration)
    );
  };
  handleTaskNameOnBlur = () => {
    this.setState({
      taskName: !this.validateName(
        this.state.scheduleTask.taskName,
        MAX_LENGTHS.TASK_NAME
      ),
    });
  };
  handleTaskDescriptionOnBlur = () => {
    this.setState({
      taskDescription: !this.validateName(
        this.state.scheduleTask.taskDescription,
        MAX_LENGTHS.TASK_DESCRIPTION
      ),
    });
  };
  handleStartMonthOnBlur = () => {
    this.setState({
      startMonth: !this.validateStartMonth(this.state.scheduleTask.startMonth),
    });
  };
  handleTaskDurationOnBlur = () => {
    this.setState({
      duration: !this.validateDuration(this.state.scheduleTask.taskDuration),
    });
  };

  validateTask = () => {
    const {scheduleTask} = this.state;
    let task = this.getTask();
    Promise.all([
      this.handleTaskNameOnBlur(),
      this.handleTaskDescriptionOnBlur(),
      this.handleStartMonthOnBlur(),
      this.handleTaskDurationOnBlur(),
    ]).then(() => {
      if (
        !this.state.taskName &&
        !this.state.taskDescription &&
        !this.state.startMonth &&
        !this.state.duration
      ) {
        task.push(scheduleTask);
        this.updateTask(task);
      }
    });
  };

  handleCreateTaskButton() {
    this.setState({
      openModal: MODALS.CREATE,
      scheduleTask: {},
    });
  }

  getTask = () => {
    // Clone data under the 'tasks' field in the root entityDataPath.
    const savedTask = _.get(this.props, 'data.tasks', undefined);
    return _.map(savedTask, (task) => {
      return task;
    });
  };

  updateTask = (task) => {
    const {entityDataPath, entityType, readOnly} = this.props;
    const {saveEntityData, validationId} = this.props;
    let included = _.concat(task);
    this.setState({
      openModal: MODALS.NONE,
    });

    // Save data to the 'tasks' field under the root entityDataPath.
    const fieldName = 'tasks';
    saveEntityData(
      entityDataPath + '.' + fieldName,
      entityType,
      included,
      validationId + '.' + fieldName
    );
  };

  handleCancelAction = () => {
    this.setState({
      openModal: MODALS.NONE,
      taskName: false,
      taskDescription: false,
      startMonth: false,
      duration: false,
    });
  };

  renderCreateTaskModal() {
    let {scheduleTask} = this.state;
    if (scheduleTask) {
      return (
        <FemaGoModal
          title="Add a task"
          size="small"
          open={this.state.openModal === MODALS.CREATE}
          buttonText="Save task"
          confirmAction={(e) => {
            this.validateTask();
          }}
          cancelAction={this.handleCancelAction}
        >
          {this.renderTaskForm()}
        </FemaGoModal>
      );
    }
  }
  renderTaskForm = () => {
    const {scheduleTask} = this.state;

    const handleInputChange = (e) => {
      let {name, value} = e.target;
      if (_.includes(['startMonth', 'taskDuration'], name)) {
        const allowOnlyPositive = true;
        value = onlyAllowNumbers(value, allowOnlyPositive);
      }
      const scheduleTask = {...this.state.scheduleTask, [name]: value};
      this.setState({scheduleTask});
    };
    return (
      <React.Fragment>
        <Form>
          <TextBoxField
            title="Task name"
            label="Task name"
            id="taskName"
            name="taskName"
            maxLength={MAX_LENGTHS.TASK_NAME}
            value={scheduleTask.taskName}
            handleChange={handleInputChange}
            handleBlur={this.handleTaskNameOnBlur}
            displayError={this.state.taskName}
            errorMessages={this.taskNameMessage}
          />
          <TextAreaField
            rows={12}
            title="Task description"
            label="Task description"
            id="taskDescription"
            name="taskDescription"
            maxLength={MAX_LENGTHS.TASK_DESCRIPTION}
            value={scheduleTask.taskDescription}
            handleChange={handleInputChange}
            handleBlur={this.handleTaskDescriptionOnBlur}
            displayError={this.state.taskDescription}
            errorMessages={this.taskDescriptionMessage}
          />
          <InlineTextBoxField
            title="Start month"
            label="Start month (number)"
            id="startMonth"
            name="startMonth"
            size="small"
            value={scheduleTask.startMonth}
            handleChange={handleInputChange}
            handleBlur={this.handleStartMonthOnBlur}
            displayError={this.state.startMonth}
            errorMessages={this.startMonthMessage}
          />
          <InlineTextBoxField
            title="Task duration"
            label="Task duration (in months)"
            id="taskDuration"
            name="taskDuration"
            size="small"
            value={scheduleTask.taskDuration}
            handleChange={handleInputChange}
            handleBlur={this.handleTaskDurationOnBlur}
            displayError={this.state.duration}
            errorMessages={this.durationMessage}
          />
        </Form>
      </React.Fragment>
    );
  };

  renderEditTaskModal() {
    const {scheduleTask, selectedIndex} = this.state;
    let task = this.getTask();
    return (
      <FemaGoModal
        title="Edit task"
        size="large"
        open={this.state.openModal === MODALS.EDIT}
        buttonText="Update task"
        confirmAction={(e) => {
          Promise.all([
            this.handleTaskNameOnBlur(),
            this.handleTaskDescriptionOnBlur(),
            this.handleStartMonthOnBlur(),
            this.handleTaskDurationOnBlur(),
          ]).then(() => {
            if (
              !this.state.taskName &&
              !this.state.taskDescription &&
              !this.state.startMonth &&
              !this.state.duration
            ) {
              task[selectedIndex] = scheduleTask;
              this.updateTask(task);
            }
          });
        }}
        cancelAction={this.handleCancelAction}
      >
        {scheduleTask ? this.renderTaskForm() : null}
      </FemaGoModal>
    );
  }

  handleRemoveTask = (index) => {
    let task = this.getTask();
    task.splice(index, 1);
    this.updateTask(task);
  };

  render() {
    const modalMessage = modalVal(this.props);

    let task = this.getTask();
    return (
      <div className="margin-top--standard margin-bottom--standard">
        <Grid.Column>
          <div className="questionText">Add tasks to the schedule</div>
          <StaticText data="Please include all tasks necessary to implement this mitigation activity; include descriptions and estimated time frames." />
        </Grid.Column>
        {task &&
          _.map(task, (sTask, index) => (
            <Card fluid="true" key={index}>
              <Grid celled="internally" fluid="true">
                <Grid.Column width={4}>
                  <Grid>
                    <Grid.Column>
                      <strong>{`Task Name`}</strong>
                      <div>{sTask.taskName}</div>
                    </Grid.Column>
                  </Grid>
                </Grid.Column>
                <Grid.Column width={10}>
                  <Grid columns={2}>
                    <Grid.Column width="5">
                      <strong>Start Month</strong>
                      <div> {sTask.startMonth}</div>
                    </Grid.Column>
                    <Grid.Column width="5">
                      <strong>Task Duration (in Months)</strong>
                      <div>{sTask.taskDuration} months</div>
                    </Grid.Column>
                  </Grid>
                  <Grid>
                    <Grid.Column>
                      <strong>Task Description</strong>
                      <div>{sTask.taskDescription}</div>
                    </Grid.Column>
                  </Grid>
                </Grid.Column>
                {!this.props.readOnly ? (
                  <Grid.Column width={2}>
                    <Grid columns={4}>
                      <Grid.Column width="10">
                        <a
                          href={`#${index}`}
                          id={index}
                          onClick={() =>
                            this.setState({
                              scheduleTask: sTask,
                              selectedIndex: index,
                              openModal: MODALS.EDIT,
                            })
                          }
                        >
                          <Icon name="pencil" />
                          Edit
                        </a>
                      </Grid.Column>
                      <a
                        href="#"
                        onClick={(e) => {
                          e.preventDefault();
                          this.handleRemoveTask(index);
                        }}
                      >
                        <Icon link name="close" color="red" />
                        Delete
                      </a>
                    </Grid>
                  </Grid.Column>
                ) : null}
              </Grid>
            </Card>
          ))}
        {!this.props.readOnly ? (
          <Grid.Column
            className={modalMessage.tasksDisplayError ? 'errorBorderLine' : ''}
          >
            <Button
              basic
              primary
              href="#"
              title="Add a task"
              onClick={() => this.handleCreateTaskButton()}
            >
              + Add a task
            </Button>
            {modalMessage.tasksDisplayError && (
              <div className="errorMessages">{modalMessage.tasksErrorMessages}</div>
            )}
          </Grid.Column>
        ) : null}
        {this.renderCreateTaskModal()}
        {this.renderEditTaskModal()}
      </div>
    );
  }
}

export default connectDynamic(TaskSchedule);
